import { useState, useEffect } from "react";
import { Button, Input } from "antd";
import { EditOutlined } from "@ant-design/icons";
import DateModalTask from "../CalenderModal/DateModalTask";
import moment from "moment";
import TimeSelect from "../CalenderModal/TimeSelect";// Time picker modal (you need to create this)

const EditableField = ({ icon, label, value, onSave, type,record }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");
  const [showDateModal, setShowDateModal] = useState(false);
  const [showTimeModal, setShowTimeModal] = useState(false);
const [selectedDate, setSelectedDate] = useState(record?.start_date || null);
const [showModal, setShowModal] = useState(false);
   const [selectedTime, setSelectedTime] = useState({
             start: null,
             end: null,
           });
    const [switchTimeStates, setSwitchTimeStates] = useState(false);
    useEffect(() => {
      setInputValue(value || ""); 
    }, [value]);
  const handleSave = () => {
    if (inputValue.trim() !== "" && inputValue !== value) {
      onSave(inputValue);
    }
    setIsEditing(false);
  };
  useEffect(() => {
  if (type === "time") {
    if (typeof value === "string" && value.includes("-")) {
      const [start, end] = value.split("-").map(v => v.trim());
      setSelectedTime({ start, end });
    } else if (typeof value === "object" && value.start && value.end) {
      setSelectedTime(value);
    }
  } else {
    setInputValue(value || "");
  }
}, [value, type]);
  // console.log("SelectedTime:", value);
    const handleSelectTime = (time) => {
      // console.log("SelectedTime:", time);
     
         const formattedStartTime = moment(time.start, "HH:mm");
         const formattedEndTime = moment(time.end, "HH:mm");
     
         const formattedTime = {
           start: formattedStartTime.format("HH:mm"),
           end: formattedEndTime.format("HH:mm")
         };
     
        //  console.log("Formatted Time:", formattedTime);
     
         setSelectedTime(formattedTime);
         onSave(formattedTime);
        //  console.log("SelectedTime:>>>>>", selectedTime)
        //  const { taskStartTime, reminderText } = formatDateTimeRem(selectedDate, selectedTime, selectedReminder);
     
        //  setDescSelectedReminder(reminderText);
    };
  const handleDateSelect = (newDate) => {
    // console.log("newDate", newDate)
    onSave(newDate)
    setShowDateModal(false);
  };
// console.log("type", type)
  const handleTimeSelect = (newTime) => {
    onSave(newTime);
    setShowTimeModal(false);
  };

  return (
    <div className="editable-field">
      <span className="icon">{icon}</span>
      <div className="field-content">
        <div className="label-invite">{label}</div>

        {isEditing && type === "text" ? (
          <Input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={handleSave}
            onPressEnter={handleSave}
            autoFocus
          />
        ) : (
         <div className="value-invite" onClick={() => type === "text" && setIsEditing(true)}>
            {type === "time" && selectedTime.start && selectedTime.end
              ? `${selectedTime.start} - ${selectedTime.end}`
              : value || "N/A"}
          </div>
        )}
      </div>

      <Button
        icon={<EditOutlined />}
        className="edit-button"
        onClick={() => {
          if (type === "date") setShowModal(true);
          else if (type === "time") setShowTimeModal(true);
          else setIsEditing(true);
        }}
      />

      {/* Date Picker Modal */}
      {type === "date" && (
       <DateModalTask
       show={showModal}
       handleClose={() => setShowModal(false)}
       onDateSelect={handleDateSelect}
       selectedDate={selectedDate}
     />
      )}

      {/* Time Picker Modal (You need to implement this) */}
      {type === "time" && (
        <TimeSelect
        show={showTimeModal}
        handleClose={() => setShowTimeModal(false)}
        onSelectTime={handleSelectTime}
        selectedTime={selectedTime}
        selectedDate={selectedDate}
      />
      )}
    </div>
  );
};

export default EditableField;
